<!-- Layout 7: Modern Template Style - Full Background with Text on Left -->
<div class="hero-section" 
     *ngIf="data?.title || data?.description || data?.buttonText"
     [style.background-image]="getBackgroundImage()"
     [style.background-color]="data?.backgroundColor || getDefaultBackgroundColor()">
  <div class="hero-container">
    <div class="hero-content">
      <h1 class="hero-title"
          *ngIf="data?.title"
          [style.color]="headingColor || getDefaultHeadingColor()"
          [style.font-family]="headingFont || 'Inter, sans-serif'"
          [ngStyle]="titleStyles">{{ data?.title }}</h1>
      <p class="hero-description"
         *ngIf="data?.description"
         [style.color]="paragraphColor || getDefaultParagraphColor()"
         [style.font-family]="bodyFont || 'Inter, sans-serif'">
        {{ data?.description }}
      </p>
      <button class="btn-primary" 
              *ngIf="data?.buttonText"
              [style.background]="primaryColor || getDefaultPrimaryColor()"
              [style.--btn-bg]="primaryColor || getDefaultPrimaryColor()"
              [style.color]="headingColor"
              (click)="onButtonClick(data?.buttonLink, $event)">
        <span class="btn-primary-text">{{ data?.buttonText }}</span>
        <span class="btn-primary-arrow" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>
    </div>
  </div>
</div>

